import { Component, OnInit } from '@angular/core';
import { PublicService } from '../public.service';
import { NavigationEnd, UrlTree } from '@angular/router';
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

// import { IdentityService } from './identity.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

// @Injectable()
export class HomeComponent implements CanActivate {
  credit = "";
  bonus = "";
  constructor(public publicservice: PublicService, public router: Router) {
    // console.log(localStorage.getItem("goToSigninPage"));
    // if (publicservice.logedIn == "false" || this.publicservice.logedIn == null) {
    //   this.router.navigate(['login']);
    // }
    // if(localStorage.getItem("goToSigninPage") == "true"){
    //   this.router.navigate(['login']);
    // }
    this.publicservice.getProfile().then((r) => {
      if(r.data.credit == null){
        this.credit = "0";
      }else{
      this.credit = r.data.credit;
      }
      if(r.data.bonus == null){
        this.bonus = "0";
      }else{
      this.bonus = r.data.bonus;
      }
    });
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    throw new Error('Method not implemented.');
  }

  ngOnInit(): void {
    if (this.publicservice.logedIn == "false") {
      this.router.navigate(['login']);
    }
  }

  getProfile() {
    this.router.navigate(['profile']);
  }

  addClick() {
    this.router.navigate(['get-location']);
  }

  aboutUsClick() {
    this.router.navigate(['about-us']);
  }

  walletClick() {
    this.router.navigate(['wallet']);
  }

  historyClick() {
    this.router.navigate(['history']);
  }

  contactusClick() {
    this.router.navigate(['contact-us']);
  }

}
